import {
  CartDataModel,
  CreateOrderFormModel,
  OrderModel,
} from "../typings/models";
import { ApiHttpService } from "../services/apiHttpService";
import { ApiResponse } from "../typings/interfaces";

const api = new ApiHttpService();

export const createOrder = async (
  data: Partial<CartDataModel & CreateOrderFormModel>
): Promise<ApiResponse<OrderModel>> => {
  // Strapi 5 expects the payload wrapped in `data` (the v4 setup relied on
  // strapi-plugin-transformer to add the wrapper server side)
  return await api.post<OrderModel>(`/orders`, { data });
};

export const getListOrdersClean = async (): Promise<
  ApiResponse<OrderModel>
> => {
  return await api.get<OrderModel>(`/orders`, {});
};

export const getFullOrder = async (
  // Strapi 5 addresses documents by documentId
  documentId: string
): Promise<ApiResponse<OrderModel>> => {
  return await api.get<OrderModel>(`/orders/${documentId}?populate=*`, {});
};
